import axios from 'axios'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeAuth from 'GlobalStores/User/StoreAuth'

const getSavedCreditCards = async ({ userCountry }) => {
    const response = await axios.get(`https://hydra.unicity.net/v5a/customers/me/creditcardaliases/${userCountry}`, {
        headers: {
            Authorization: `Bearer ${storeAuth.GetToken()}`,
            'Content-Type': 'application/json',
            'x-application': `asia.fg-${storeCountry.Country2().toLowerCase()}`
        }
    })
    return response
}

const deleteSavedCreditCard = async ({ cardAlias, userCountry }) => {
    const response = await axios.delete(`https://hydra.unicity.net/v5a/customers/me/creditcardaliases/${userCountry}/${cardAlias}`, {
        headers: {
            Authorization: `Bearer ${storeAuth.GetToken()}`,
            'Content-Type': 'application/json',
            'x-application': `asia.fg-${storeCountry.Country2().toLowerCase()}`
        }
    })

    return response
}

const saveCreditCard = async ({ methodDetails, userCountry }) => {
    const response = await axios.post(`https://hydra.unicity.net/v5a/customers/me/creditcardaliases/${userCountry}`, methodDetails, {
        headers: {
            Authorization: `Bearer ${storeAuth.GetToken()}`,
            'Content-Type': 'application/json',
            'x-application': `asia.fg-${storeCountry.Country2().toLowerCase()}`
        }
    })

    return response
}

export const savedCreditCardApis = {
    getSavedCreditCards,
    deleteSavedCreditCard,
    saveCreditCard
}
